import React from 'react';
import { Box, Typography } from '@mui/material';

function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}

const UserName = ({ email }) => {

  // let tempUser = useSelector(state => state.user.user_details?.email)
  // console.log(tempUser)
  if (email) {
    const fullName = email.toString().split("@")[0]
    const firstName = fullName.toString()
      .split(".")
      .map((w) => {
        return w[0].toUpperCase() + w.substr(1).toLowerCase()
      }).join(' ');
    // console.log("this is fullName", fullName)
    // console.log("this is firstName yes", firstName)

    return (
      <>
        <Box
          style={{
            width: '100%'
            // display: 'inline-flex',
            // justifyContent: 'space-between',
          }}
        >
          <Typography
            variant="h5"
            noWrap
            style={{
              float: 'center'
            }}
          >
            Hi {toTitleCase(firstName)}
          </Typography>
        </Box>
      </>
    );
  } else {
    return null
  }

}
export default UserName;
